// eslint-disable-next-line import/order
import type { ComponentType, ClassAttributes, ImgHTMLAttributes } from 'react';

import { styled, type StyledProps } from '@compiled/react';

// eslint-disable-next-line import/order
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ProfileSectionPrimaryUserImg: ComponentType<
	ClassAttributes<HTMLImageElement> & ImgHTMLAttributes<HTMLImageElement> & StyledProps
	// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
> = styled.img({
	width: '72px',
	height: '72px',
	borderRadius: token('radius.xlarge'),
});
